import React, { useState, useEffect, useRef, useCallback } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { Autocomplete, Box, TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { getPriestEvents } from "../../../Apiservices/Auth/servers/fetchProviderData";
import { useDispatch, useSelector } from "react-redux";
import { fetchserviceitemssecond } from "../../../Apiservices/Auth/servers/fetchProviderData";
import CateringServiceforuser from "../../../component/newcateringuiforproviderlist/CateringServiceforuser";
import {
  setCommonData,
  closeServiceDialog,
  resetServiceBooking,
  openProviderDialog,
  setEventId,
  setAvailableEvents,
  setTentItems,
  setServiceType,
  showTentItemsSelection,
  showCateringSelection,
  showServiceForm,
  closeDialogForLogin,
  setShouldProcessCartAfterLogin
} from "../../../store/serviceBookingSlice";
import config from "../../../config";
import { useNavigate } from "react-router-dom";
import useWindowSize from "../../../util/useWindowSize";
import styles from './ServiceBookingDialog.module.css';
import CustomCalendar from "../Customcalender";
import Tenthouseaccordian from '../../../component/EventServices/Tenthouseaccordian';

// Import Venue related components
import { getVenuesListByLocation } from "../../../Apiservices/Auth/servers/fetchProviderData";
import ProviderListingCard from "../../../component/ServiceProvider/ProviderListingCard";
import { createEvent } from "../../../Apiservices/Auth/servers/createEvents";

const ServiceBookingDialog = () => {
  const isIndiaRegion = config.isIndia;
  const countryRestriction = isIndiaRegion ? "in" : "us";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    isDialogOpen,
    serviceType,
    commonData,
    availableEvents,
    activeSelection
  } = useSelector(state => state.serviceBooking);

  const [location, setLocation] = useState({ lat: 0, lng: 0 });
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [eventDate, setEventDate] = useState(null);
  const [eventTime, setEventTime] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [whoseEvent, setWhoseEvent] = useState("");
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [placesService, setPlacesService] = useState(null);
  const [isResumingFromLogin, setIsResumingFromLogin] = useState(false);
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [errors, setErrors] = useState({});
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
  const [tentItemsData, setTentItemsData] = useState([]);
  const [loadingTentItems, setLoadingTentItems] = useState(false);

  // Venue specific state
  const [venueData, setVenueData] = useState([]);
  const [loadingVenues, setLoadingVenues] = useState(false);
  const [selectedVenueId, setSelectedVenueId] = useState(null);
  const [selectedSpaceId, setSelectedSpaceId] = useState(null);
  const [venueSearchPerformed, setVenueSearchPerformed] = useState(false);
  const [isCreatingEvent, setIsCreatingEvent] = useState(false);

  const { width } = useWindowSize();
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyCfBZYkyctvp5zTzY-Rb1dfTYGW6TWSp7U';
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: ["places", "maps"],
  });

  const mapRef = useRef(null);

  // ✅ SIMPLIFIED: Single useEffect for dialog state management
  useEffect(() => {
    if (!isDialogOpen) {
      setIsResumingFromLogin(false);
      return;
    }

    // Handle pending data from localStorage (for login redirects)
    const pendingServiceData = localStorage.getItem('pendingServiceData');
    if (pendingServiceData) {
      try {
        const serviceData = JSON.parse(pendingServiceData);
        localStorage.removeItem('pendingServiceData');

        dispatch(setServiceType(serviceData.serviceType));
        dispatch(setCommonData(serviceData.commonData));

        if (serviceData.currentStep === 'cateringSelection') {
          setTimeout(() => {
            dispatch(showCateringSelection());
          }, 0);
          return;
        } else if (serviceData.currentStep === 'providerSelection') {
          dispatch(openProviderDialog());
          dispatch(closeDialogForLogin());
          return;
        } else if (serviceData.currentStep === 'venueSelection') {
          // For venue, fetch venues after login
          setTimeout(() => {
            fetchVenues();
          }, 0);
          return;
        }
      } catch (error) {
        console.error("Error parsing pending data:", error);
      }
    }

    const hasBasicData = commonData.address && commonData.eventDate;
    const hasTentItems = commonData.selectedTentItems?.length > 0;
    const hasCateringItems = commonData.cateringSelectedItems?.length > 0;

    if (activeSelection === 'tentItems' || activeSelection === 'cateringSelection') {
      return;
    }

    if (serviceType === 'catering' && activeSelection === 'serviceForm' && hasBasicData) {
      setTimeout(() => {
        dispatch(showCateringSelection());
      }, 0);
      return;
    }

    if (serviceType === 'tent' && activeSelection === 'serviceForm' && hasBasicData) {
      setTimeout(() => {
        dispatch(showTentItemsSelection());
        fetchTentItems();
      }, 0);
      return;
    }

    // VENUE: If service type is venue and we have basic data, show venue list
    if (serviceType === 'venue' && hasBasicData && !venueSearchPerformed && isLoggedIn) {
      fetchVenues();
      return;
    }

    if (!hasBasicData) {
      dispatch(showServiceForm());
    } else if (serviceType === 'tent' && hasTentItems) {
      dispatch(showTentItemsSelection());
      fetchTentItems();
    } else if (serviceType === 'catering' && hasCateringItems) {
      dispatch(showCateringSelection());
    } else {
      dispatch(showServiceForm());
    }

    // Fetch events if needed
    if (availableEvents.length === 0) {
      getPriestEvents("").then(response => {
        const categories = response;
        if (Array.isArray(categories)) {
          const allEvents = [];
          categories.forEach((category) => {
            if (category && category.events && Array.isArray(category.events)) {
              category.events.forEach(event => {
                if (event && event.id) {
                  allEvents.push(event);
                }
              });
            }
          });
          dispatch(setAvailableEvents(allEvents));
        } else {
          dispatch(setAvailableEvents([]));
        }
      }).catch(error => {
        console.error("❌ Error fetching events:", error);
        dispatch(setAvailableEvents([]));
      });
    }
  }, [isDialogOpen, activeSelection, serviceType, commonData, dispatch, venueSearchPerformed, isLoggedIn]);

  // Google Maps initialization
  useEffect(() => {
    if (isLoaded && window.google) {
      setAutocompleteService(new window.google.maps.places.AutocompleteService());
      setPlacesService(new window.google.maps.places.PlacesService(document.createElement('div')));
    }
  }, [isLoaded]);

  const [showGothramDialog, setShowGothramDialog] = useState(false);
  const [gothramText, setGothramText] = useState("");

  // Initialize form fields from Redux when dialog opens
  useEffect(() => {
    if (isDialogOpen && commonData) {
      setAddress(commonData.address || "");
      setLocation({
        lat: commonData.latitude || 0,
        lng: commonData.longitude || 0
      });
      setArea(commonData.area || "");
      setCity(commonData.city || "");
      setState(commonData.state || "");
      setCountry(commonData.country || "");
      setEventDate(commonData.eventDate ? new Date(commonData.eventDate) : null);
      setEventTime(commonData.eventTime ? new Date(commonData.eventTime) : null);
      setSelectedEvent(commonData.eventId || "");
      setWhoseEvent(commonData.whoseEvent || "");
    }
  }, [isDialogOpen, commonData]);

  // ✅ Fetch Venues
  const fetchVenues = useCallback(async () => {
    if (!commonData.latitude || !commonData.longitude) {
      console.error("Location data missing");
      return;
    }

    setLoadingVenues(true);
    setVenueSearchPerformed(true);

    try {
      const venueParams = {
        noOfPersons: 50, // Default value
        latitude: commonData.latitude,
        longitude: commonData.longitude,
        eventId: commonData.eventId || null,
      };

      const response = await getVenuesListByLocation(
        commonData.latitude,
        commonData.longitude,
        commonData.eventId,
        venueParams
      );

      console.log("Venues fetched:", response);
      setVenueData(response.data || []);
    } catch (error) {
      console.error("Error fetching venues:", error);
      setVenueData([]);
    } finally {
      setLoadingVenues(false);
    }
  }, [commonData]);

  // ✅ Tent items fetch
  const fetchTentItems = useCallback(async () => {
    setLoadingTentItems(true);
    try {
      const itemsdata = await fetchserviceitemssecond();
      setTentItemsData(itemsdata.data);
    } catch (error) {
      console.error("Error fetching tent items:", error);
      setTentItemsData([]);
    } finally {
      setLoadingTentItems(false);
    }
  }, []);

  // ✅ Create Event for Venue - returns the created event data
  const createEventForVenue = useCallback(async (venueId, spaceId) => {
    setIsCreatingEvent(true);
    try {
      // Prepare event data
      const eventBody = {
        eventTitle: commonData.whoseEvent || "Event",
        event: {
          event: commonData.eventName || commonData.eventType || "Venue Event",
          id: commonData.eventId || null
        },
        eventDesc: commonData.whoseEvent || "",
        Date: commonData.eventDate,
        EndDate: commonData.eventDate,
        Address: commonData.address,
        area: commonData.area,
        city: commonData.city,
        state: commonData.state,
        country: commonData.country,
        locationLat: commonData.latitude,
        locationLong: commonData.longitude,
        venueId: venueId,
        spaceId: spaceId
      };

      console.log("Creating event with data:", eventBody);
      const response = await createEvent(eventBody);
      console.log("Event created successfully for venue:", response);

      // Store event ID in localStorage for persistence
      if (response && response.id) {
        localStorage.setItem('currentEventId', response.id);
        localStorage.setItem('currentEventData', JSON.stringify({
          ...eventBody,
          id: response.id
        }));
      }

      return response;
    } catch (error) {
      console.error("Error creating event for venue:", error);
      throw error;
    } finally {
      setIsCreatingEvent(false);
    }
  }, [commonData]);

  // ✅ Form submission
  const handleNext = useCallback(async () => {
    if (!validateForm()) return;

    const eventName = availableEvents.find(event => event.id === selectedEvent)?.name || '';
    const defaultWhoseEvent = whoseEvent || eventName || `Quick ${serviceType ? serviceType.charAt(0).toUpperCase() + serviceType.slice(1) : 'Service'} Booking`;

    const commonDataPayload = {
      location: address,
      address,
      latitude: location.lat,
      longitude: location.lng,
      area,
      city,
      state,
      country,
      eventDate: eventDate ? eventDate.toISOString() : null,
      eventTime: eventTime ? eventTime.toISOString() : null,
      eventType: eventName,
      whoseEvent: defaultWhoseEvent,
      eventId: selectedEvent,
      eventName: eventName
    };

    dispatch(setCommonData(commonDataPayload));

    // Handle service type routing
    if (serviceType === 'priest') {
      if (!isLoggedIn) {
        const pendingServiceData = {
          commonData: commonDataPayload,
          serviceType: 'priest',
          currentStep: 'providerSelection'
        };
        localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
        dispatch(closeDialogForLogin());
        navigate('/login');
        localStorage.setItem('showEventTabsAfterLogin', 'true');
      } else {
        dispatch(closeDialogForLogin());
        dispatch(openProviderDialog());
      }
    } else if (serviceType === 'tent') {
      if (!isLoggedIn) {
        const pendingServiceData = {
          commonData: commonDataPayload,
          serviceType: 'tent',
          currentStep: 'tentSelection'
        };
        localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
        dispatch(closeDialogForLogin());
        navigate('/login');
        localStorage.setItem('showEventTabsAfterLogin', 'true');
      } else {
        dispatch(showTentItemsSelection());
        await fetchTentItems();
      }
    } else if (serviceType === 'catering') {
      if (isLoggedIn) {
        dispatch(setCommonData({
          ...commonDataPayload,
          cateringSelectedItems: [],
          cateringQuantity: 1
        }));
        dispatch(showCateringSelection());
      } else {
        const pendingServiceData = {
          commonData: commonDataPayload,
          serviceType: 'catering',
          currentStep: 'cateringSelection'
        };
        localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
        dispatch(closeDialogForLogin());
        navigate('/login');
        localStorage.setItem('showEventTabsAfterLogin', 'true');
      }
    } else if (serviceType === 'venue') {
      // For venue: store data and fetch venues
      if (!isLoggedIn) {
        // Save pending data for after login
        const pendingServiceData = {
          commonData: commonDataPayload,
          serviceType: 'venue',
          currentStep: 'venueSelection'
        };
        localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
        dispatch(closeDialogForLogin());
        navigate('/login');
        localStorage.setItem('showEventTabsAfterLogin', 'true');
      } else {
        // User is logged in - fetch and show venues
        await fetchVenues();
        // The venues will be displayed in the dialog
      }
    }
  }, [address, location, area, city, state, country, eventDate, eventTime, selectedEvent, whoseEvent, serviceType, dispatch, fetchTentItems, navigate, isLoggedIn, availableEvents, fetchVenues]);

  // ✅ Form validation
  const validateForm = useCallback(() => {
    const newErrors = {};
    if (!address) newErrors.address = "Event location is required.";
    if (!eventDate) newErrors.eventDate = "Event date is required.";
    if (serviceType === 'priest' && !selectedEvent) {
      newErrors.selectedEvent = "Event type is required for priest booking.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [address, eventDate, selectedEvent, serviceType]);

  // ✅ Handlers
  const handleTentItemsNext = useCallback((selectedItems) => {
    dispatch(setTentItems(selectedItems));
    const serviceIds = selectedItems.map(item => item.id);
    const updatedCommonData = {
      ...commonData,
      tentServiceIds: serviceIds,
      selectedTentItems: selectedItems
    };
    dispatch(setCommonData(updatedCommonData));

    if (!isLoggedIn) {
      const pendingServiceData = {
        commonData: updatedCommonData,
        serviceType: 'tent',
        currentStep: 'providerSelection'
      };
      localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
      dispatch(closeDialogForLogin());
      navigate('/login');
    } else {
      dispatch(openProviderDialog());
      dispatch(closeDialogForLogin());
    }
  }, [commonData, dispatch, isLoggedIn, navigate]);

  const handleCateringNextforuser = useCallback((cateringData, quantity) => {
    const updatedCommonData = {
      ...commonData,
      cateringData: cateringData,
      cateringQuantity: quantity,
    };
    dispatch(setCommonData(updatedCommonData));

    if (isLoggedIn) {
      dispatch(openProviderDialog());
      dispatch(closeDialogForLogin());
    } else {
      const pendingServiceData = {
        commonData: updatedCommonData,
        serviceType: 'catering',
        currentStep: 'providerSelection'
      };
      localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
      dispatch(closeDialogForLogin());
      navigate('/login');
    }
  }, [commonData, dispatch, navigate]);

  // ✅ Venue handler - when a venue is selected
  const handleVenueSelect = useCallback(async (venueId, spaceId) => {
    setSelectedVenueId(venueId);
    setSelectedSpaceId(spaceId);

    // Store the selected venue data in Redux
    const updatedCommonData = {
      ...commonData,
      selectedVenueId: venueId,
      selectedSpaceId: spaceId,
    };
    dispatch(setCommonData(updatedCommonData));

    // If user is logged in, create event and navigate to venue booking
    if (isLoggedIn) {
      try {
        // Create event before navigating
        const eventResponse = await createEventForVenue(venueId, spaceId);
        console.log("Navigating to venue booking with eventResponse 1:", eventResponse);

        // Prepare event details for navigation
        const eventDetails = {
          eventId: commonData.eventId || eventResponse?.event?.id,
          eventTitle: commonData.eventName || commonData.eventType || commonData.whoseEvent || "Event",
          eventDescription: commonData.whoseEvent || "",
          Date: commonData.eventDate,
          locationLat: commonData.latitude,
          locationLong: commonData.longitude,
          address: commonData.address,
          area: commonData.area,
          city: commonData.city,
          state: commonData.state,
          country: commonData.country,
          venueId: venueId,
          spaceId: spaceId,
        };

        console.log("Navigating to venue booking with event details:", eventDetails);

        // Navigate to venue booking with event details
        navigate(`/venue-booking/${venueId}`, {
          state: {
            venueId: venueId,
            spaceId: spaceId,
            eventId: eventResponse?.id || commonData.eventId,
            eventData: eventResponse,
            eventDetails: eventDetails,
            // Additional data that might be needed
            bookingData: {
              eventId: eventResponse?.id,
              venueId: venueId,
              spaceId: spaceId,
              eventDate: commonData.eventDate,
              eventTime: commonData.eventTime,
              address: commonData.address,
              latitude: commonData.latitude,
              longitude: commonData.longitude,
            }
          }
        });

        dispatch(closeDialogForLogin());
        dispatch(closeServiceDialog());

      } catch (error) {
        console.error("Error creating event for venue booking:", error);
        alert("Failed to create event. Please try again.");
      }
    } else {
      // Save pending data and redirect to login
      const pendingServiceData = {
        commonData: updatedCommonData,
        serviceType: 'venue',
        currentStep: 'providerSelection',
        selectedVenueId: venueId,
        selectedSpaceId: spaceId,
      };
      localStorage.setItem('pendingServiceData', JSON.stringify(pendingServiceData));
      localStorage.setItem('pendingVenueBooking', JSON.stringify({
        venueId: venueId,
        spaceId: spaceId,
        commonData: updatedCommonData
      }));
      dispatch(closeDialogForLogin());
      navigate('/login');
      localStorage.setItem('showEventTabsAfterLogin', 'true');
    }
  }, [commonData, dispatch, navigate, isLoggedIn, createEventForVenue]);

  const handleClose = useCallback(() => {
    setLocation({ lat: 0, lng: 0 });
    setAddress("");
    setArea("");
    setCity("");
    setState("");
    setCountry("");
    setEventDate(null);
    setEventTime(null);
    setSelectedEvent("");
    setWhoseEvent("");
    setLocationSuggestions([]);
    setErrors({});
    setTentItemsData([]);
    setLoadingTentItems(false);
    setVenueData([]);
    setSelectedVenueId(null);
    setSelectedSpaceId(null);
    setVenueSearchPerformed(false);
    setIsCreatingEvent(false);

    dispatch(closeServiceDialog());
    dispatch(resetServiceBooking());
  }, [dispatch]);

  const handleBackToServiceForm = useCallback(() => {
    dispatch(showServiceForm());
    setVenueSearchPerformed(false);
    setVenueData([]);
  }, [dispatch]);

  const handleEventChange = useCallback((event) => {
    const eventId = event.target.value;
    setSelectedEvent(eventId);
    const selectedEventData = availableEvents.find(event => event.id === eventId);
    if (selectedEventData) {
      dispatch(setEventId({
        id: selectedEventData.id,
        name: selectedEventData.name
      }));
    }
  }, [availableEvents, dispatch]);

  // ✅ Google Maps functions
  const fetchAddress = useCallback((lat, lng) => {
    if (!isLoaded) return;

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const result = results[0];
        const addressComponents = result.address_components;
        const getComponent = (type) =>
          addressComponents.find((comp) => comp.types.includes(type))?.long_name || "";

        setAddress(result.formatted_address);
        setArea(getComponent("sublocality") || getComponent("locality"));
        setCity(getComponent("locality"));
        setState(getComponent("administrative_area_level_1"));
        setCountry(getComponent("country"));
      }
    });
  }, [isLoaded]);

  useEffect(() => {
    if (!location.lat || !location.lng) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ lat: latitude, lng: longitude });
            fetchAddress(latitude, longitude);
          },
          (error) => console.error("Error fetching location:", error)
        );
      }
    } else {
      fetchAddress(location.lat, location.lng);
    }
  }, [location.lat, location.lng, fetchAddress]);

  const handleMapClick = useCallback((e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setLocation({ lat, lng });
    fetchAddress(lat, lng);
  }, [fetchAddress]);

  const handleMarkerDragEnd = useCallback((e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setLocation({ lat, lng });
    fetchAddress(lat, lng);
  }, [fetchAddress]);

  const useCurrentLocation = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude, lng: longitude });
          fetchAddress(latitude, longitude);
        },
        (error) => {
          console.error("Error fetching location:", error);
          alert("Unable to fetch location. Please enable location services.");
        }
      );
    }
  }, [fetchAddress]);

  const handleLocationInputChange = useCallback((event, value) => {
    setAddress(value);
    if (value.length > 2 && autocompleteService) {
      autocompleteService.getPlacePredictions(
        {
          input: value,
          types: ['establishment', 'geocode'],
          componentRestrictions: { country: countryRestriction }
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            setLocationSuggestions(predictions.map(prediction => ({
              description: prediction.description,
              placeId: prediction.place_id
            })));
          } else {
            setLocationSuggestions([]);
          }
        }
      );
    } else {
      setLocationSuggestions([]);
    }
  }, [autocompleteService]);

  const handleLocationSelect = useCallback((event, value) => {
    if (value && placesService) {
      const request = {
        placeId: value.placeId,
        fields: ['geometry', 'formatted_address', 'name', 'address_components']
      };

      placesService.getDetails(request, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          setLocation({ lat, lng });
          setAddress(place.formatted_address || value.description);

          if (place.address_components) {
            const getComponent = (type) =>
              place.address_components.find((comp) => comp.types.includes(type))?.long_name || "";

            setArea(getComponent("sublocality") || getComponent("locality"));
            setCity(getComponent("locality"));
            setState(getComponent("administrative_area_level_1"));
            setCountry(getComponent("country"));
          }

          if (mapRef.current) {
            mapRef.current.panTo({ lat, lng });
            mapRef.current.setZoom(15);
          }
        }
      });
    }
    setLocationSuggestions([]);
  }, [placesService]);

  // ✅ Header logic
  const getDialogHeader = useCallback(() => {
    if (activeSelection === 'tentItems') {
      return 'Select Tent Items - Step 1 of 2';
    }
    if (activeSelection === 'cateringSelection') {
      return 'Select Catering Options - Step 1 of 2';
    }
    if (activeSelection === 'venueSelection' || serviceType === 'venue') {
      return 'Select Venue - Step 1 of 2';
    }

    switch (serviceType) {
      case 'catering': return 'Order Catering Service - Step 1 of 2';
      case 'priest': return 'Book a Priest';
      case 'tent': return 'Rent from Tent House - Step 1 of 2';
      case 'venue': return 'Book a Venue - Step 1 of 2';
      default: return 'Book Service';
    }
  }, [activeSelection, serviceType]);

  // ✅ Render Venue List
  const renderVenueList = useCallback(() => {
    if (loadingVenues) {
      return (
        <div className={styles.loadingContainer}>
          <div className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></div>
          <p>Loading venues...</p>
        </div>
      );
    }

    if (isCreatingEvent) {
      return (
        <div className={styles.loadingContainer}>
          <div className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></div>
          <p>Creating your event and finding venues...</p>
        </div>
      );
    }

    if (venueData.length === 0) {
      return (
        <div className={styles.noDataContainer}>
          <p>No venues found in your area.</p>
          <button
            className={styles.retryButton}
            onClick={fetchVenues}
          >
            Try Again
          </button>
          <button
            className={styles.backButton}
            onClick={handleBackToServiceForm}
          >
            Back
          </button>
        </div>
      );
    }

    return (
      <div className={styles.venueListContainer}>
        <div className={styles.venueList}>
          {venueData.map((venue) => {
            const fullName = [venue.firstName, venue.lastName].filter(Boolean).join(" ");

            return (
              <ProviderListingCard
                key={venue.id}
                serviceId="10"
                providerid={venue.id}
                event={{
                  id: commonData.eventId || 0,
                  eventTitle: commonData.eventName || commonData.eventType || '',
                  Date: commonData.eventDate || new Date().toISOString(),
                  locationLat: commonData.latitude,
                  locationLong: commonData.longitude,
                }}
                latitude={venue.latitude}
                longitude={venue.longitude}
                name={venue.name || fullName}
                address={venue.formattedAddress || venue.shortAddress}
                distance={venue.distanceInMeter}
                mobile={venue.mobile}
                email={venue.email}
                price={venue.price}
                discount={venue.discountPrice}
                validUpto={venue.discountValidUpto}
                rating={venue.rating || 4.5}
                providerFirstName={venue.provider?.firstName}
                providerLastName={venue.provider?.lastName}
                shortAddress={venue.shortAddress || venue.formattedAddress}
                distanceInMeter={venue.distanceInMeter}
                primaryImage={venue.primaryImage}
                rules={venue.rules || []}
                sections={venue.spaces || venue.sections || []}
                expectedGuestCount={50} // Default
                selectedSpaceId={selectedSpaceId}
                eventStartDate={commonData.eventDate}
                eventEndDate={commonData.eventDate}
                rsvpGuestCount={0}
                onSpaceSelected={(spaceId) => {
                  setSelectedSpaceId(spaceId);
                  setSelectedVenueId(venue.id);
                }}
                onBookNow={(spaceId) => {
                  handleVenueSelect(venue.id, spaceId || selectedSpaceId);
                }}
              />
            );
          })}
        </div>
        <div className={styles.buttonGroup}>
          <Button
            size="small"
            className={styles.backButton}
            label="Back"
            onClick={handleBackToServiceForm}
          />
          <Button
            size="small"
            className={styles.cancelButton}
            label="Cancel"
            onClick={handleClose}
          />
        </div>
      </div>
    );
  }, [venueData, loadingVenues, commonData, selectedSpaceId, handleVenueSelect, handleBackToServiceForm, handleClose, fetchVenues, isCreatingEvent]);

  // ✅ Render functions
  const renderTentItemsSelection = useCallback(() => (
    loadingTentItems ? (
      <div className={styles.loadingContainer}>
        <div className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></div>
        <p>Loading tent items...</p>
      </div>
    ) : (
      <div className={styles.quickservice_tentitemsshowcontainer}>
        <Tenthouseaccordian
          serviceData={tentItemsData}
          onNext={handleTentItemsNext}
          onClose={handleBackToServiceForm}
        />
      </div>
    )
  ), [loadingTentItems, tentItemsData, handleTentItemsNext, handleBackToServiceForm]);

  const renderCateringSelection = useCallback(() => (
    <div className={styles.quickservice_cateringshowcontainer}>
      <CateringServiceforuser
        onNext={handleCateringNextforuser}
        onClose={handleBackToServiceForm}
        isResuming={true}
        selectedCuisineType={commonData.cateringCuisineType ?? null}
        selectedMeal={commonData.cateringMealType ?? null}
      />
    </div>
  ), [handleCateringNextforuser, handleBackToServiceForm, commonData.cateringCuisineType, commonData.cateringMealType]);

  const renderServiceForm = useCallback(() => (
    <div className={styles.eventFormInner}>
      <div className={styles.eventFormBody}>
        <Box className={styles.mapContainer}>
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={{
                height: width > 768 ? "30vh" : width > 480 ? "40vh" : "180px",
                width: "100%",
              }}
              center={location}
              zoom={15}
              onClick={handleMapClick}
              onLoad={(map) => (mapRef.current = map)}
            >
              <MarkerF
                position={location}
                draggable
                onDragEnd={handleMarkerDragEnd}
              />
            </GoogleMap>
          ) : (
            <div className={styles.loadingContainer}>Loading Map...</div>
          )}
          <Button
            size="small"
            label="Use Current Location"
            onClick={useCurrentLocation}
            className={styles.currentLocationButton}
          />
        </Box>

        <Box className={styles.formContainer}>

          {serviceType === 'priest' && (
            <FormControl fullWidth size="small" className={styles.formField}>
              <InputLabel
                sx={{
                  fontFamily: "Inter !important",
                  color: "#888",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "24px",
                }}
              >
                Select Event Type
              </InputLabel>
              <Select
                value={selectedEvent}
                onChange={handleEventChange}
                label="Select Event Type"
                error={Boolean(errors.selectedEvent)}
                sx={{
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, rgba(214,241,255,0.9), rgba(178,224,247,0.55))",
                  fontFamily: "Inter !important",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "24px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0,0,0,0.15)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0,0,0,0.25)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#3b82f6",
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5,
                      overflowY: 'auto',
                      borderRadius: '12px',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    },
                  },
                }}
              >
                {availableEvents.map((event) => (
                  <MenuItem key={event.id} value={event.id} sx={{ fontFamily: "Inter !important" }}>
                    {event.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.selectedEvent && (
                <div className={styles.errorText}>{errors.selectedEvent}</div>
              )}
            </FormControl>
          )}

          <Autocomplete
            freeSolo
            options={locationSuggestions}
            getOptionLabel={(option) =>
              typeof option === 'string' ? option : option.description
            }
            onInputChange={handleLocationInputChange}
            onChange={handleLocationSelect}
            value={address}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Event Location/Venue"
                size="small"
                fullWidth
                error={Boolean(errors.address)}
                helperText={errors.address || ""}
                className={`${styles.formField} ${errors.address ? styles.errorField : ''}`}
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    borderRadius: "10px",
                    background: "linear-gradient(135deg, rgba(214,241,255,0.9), rgba(178,224,247,0.55))",
                    fontFamily: "Inter !important",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0,0,0,0.15)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0,0,0,0.25)",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#3b82f6",
                    }
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontFamily: "Inter !important",
                    color: "#888",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                  },
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.placeId} style={{ fontFamily: "Inter !important" }}>
                {option.description}
              </li>
            )}
          />

          <CustomCalendar
            value={eventDate}
            onChange={(e) => setEventDate(e.value)}
            placeholder="Event Date & Time"
            showTime={true}
            minDate={new Date()}
            showIcon={true}
            inputStyle={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, rgba(214,241,255,0.9), rgba(178,224,247,0.55))",
              fontFamily: "Inter !important",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
              width: "100%",
              padding: "10px 14px",
              border: errors.eventDate ? "1px solid red" : "1px solid rgba(0, 0, 0, 0.15)",
              cursor: 'pointer',
              boxSizing: 'border-box'
            }}
          />
          {errors.eventDate && (
            <div className={styles.errorText}>{errors.eventDate}</div>
          )}

          <div className={styles.buttonGroup}>
            <Button
              size="small"
              type="button"
              className={styles.submitButton}
              label="Next"
              onClick={handleNext}
            />
            <Button
              size="small"
              className={styles.cancelButton}
              label="Cancel"
              onClick={handleClose}
            />
          </div>
        </Box>
      </div>
    </div>
  ), [isLoaded, width, location, handleMapClick, handleMarkerDragEnd, useCurrentLocation, whoseEvent, errors, serviceType, selectedEvent, handleEventChange, availableEvents, locationSuggestions, handleLocationInputChange, handleLocationSelect, address, eventDate, handleNext, handleClose]);

  // ✅ Main render
  return (
    <Dialog
      header={getDialogHeader()}
      visible={isDialogOpen}
      onHide={handleClose}
      closable={true}
      breakpoints={{ "960px": "75vw", "640px": "100vw" }}
      className={styles.dialogContainer}
    >
      {activeSelection === 'tentItems' ? renderTentItemsSelection() :
        activeSelection === 'cateringSelection' ? renderCateringSelection() :
          serviceType === 'venue' && venueSearchPerformed ? renderVenueList() :
            renderServiceForm()}
    </Dialog>
  );
};

export default React.memo(ServiceBookingDialog);